<script setup lang="ts" generic="T extends Record<string, any>">
import { defineAsyncComponent, markRaw } from 'vue'

import type { Media } from '@fondof-ui/components/media/types'

const ComponentBuilder = defineAsyncComponent(() => {
  return import('@fondof-ui/components/content-builder/ComponentBuilder.vue')
})

const TeaserCardGroup = defineAsyncComponent(() => {
  return import(
    '@storefront-satch/components/organisms/teaser-card-group/TeaserCardGroup.vue'
  )
})

const TeaserTileGroup = defineAsyncComponent(() => {
  return import(
    '@storefront-satch/components/organisms/teaser-tile-group/TeaserTileGroup.vue'
  )
})

const ProductGridBySkus = defineAsyncComponent(() => {
  return import(
    '@storefront-satch/components/organisms/product/ProductGridBySkus.vue'
  )
})

const ProductTeaserBySku = defineAsyncComponent(() => {
  return import(
    '@storefront-satch/components/organisms/product-teaser/ProductTeaser.vue'
  )
})

const ProductsBySelection = defineAsyncComponent(() => {
  return import(
    '@storefront-satch/components/organisms/product/ProductsBySelection.vue'
  )
})

const Hero = defineAsyncComponent(() => {
  return import('@storefront-satch/components/molecules/hero/Hero.vue')
})

const TextBlock = defineAsyncComponent(() => {
  return import(
    '@storefront-satch/components/molecules/text-block/TextBlock.vue'
  )
})

const MediaGroup = defineAsyncComponent(() => {
  return import(
    '@storefront-satch/components/molecules/media-group/MediaGroup.vue'
  )
})

const IframeEmbed = defineAsyncComponent(() => {
  return import(
    '@storefront-satch/components/molecules/iframe-embed/IframeEmbed.vue'
  )
})

const Table = defineAsyncComponent(() => {
  return import('@storefront-satch/components/molecules/table/Table.vue')
})

const Animation = defineAsyncComponent(() => {
  return import(
    '@storefront-satch/components/molecules/animation/Animation.vue'
  )
})

const props = defineProps<{
  contentCollection: T
  backgroundColor?: string
  backgroundImage?: Media
}>()

const componentMap = {
  ProductGridBySkus: markRaw(ProductGridBySkus),
  ProductTeaserBySku: markRaw(ProductTeaserBySku),
  ProductsBySelection: markRaw(ProductsBySelection),
  ContentCollection: markRaw(ComponentBuilder),
  Hero: markRaw(Hero),
  TextBlock: markRaw(TextBlock),
  TeaserCardGroup: markRaw(TeaserCardGroup),
  TeaserTileGroup: markRaw(TeaserTileGroup),
  MediaGroup: markRaw(MediaGroup),
  Iframe: markRaw(IframeEmbed),
  Table: markRaw(Table),
  Animation: markRaw(Animation),
}
</script>
<template>
  <ComponentBuilder
    :collection="props.contentCollection"
    :component-map="componentMap"
    :background-color="props.backgroundColor"
    :background-image="props.backgroundImage"
  />
</template>
